var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_588_24200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2574 7.14125C15.2574 7.03322 15.169 6.94482 15.0609 6.94482L13.4404 6.95219L10.9998 9.86179L8.56161 6.95465L6.93862 6.94728C6.83058 6.94728 6.74219 7.03322 6.74219 7.14371C6.74219 7.19036 6.75937 7.23456 6.78884 7.27139L9.98326 11.0772L6.78884 14.8805C6.75917 14.9165 6.74271 14.9616 6.74219 15.0082C6.74219 15.1163 6.83058 15.2046 6.93862 15.2046L8.56161 15.1973L10.9998 12.2877L13.4379 15.1948L15.0585 15.2022C15.1665 15.2022 15.2549 15.1163 15.2549 15.0058C15.2549 14.9591 15.2377 14.9149 15.2083 14.8781L12.0187 11.0747L15.2132 7.26893C15.2426 7.23456 15.2574 7.1879 15.2574 7.14125Z",
    fill: "#FF4D4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 0.0241699C4.92545 0.0241699 0 4.94962 0 11.0242C0 17.0987 4.92545 22.0242 11 22.0242C17.0746 22.0242 22 17.0987 22 11.0242C22 4.94962 17.0746 0.0241699 11 0.0241699ZM11 20.1581C5.9567 20.1581 1.86607 16.0675 1.86607 11.0242C1.86607 5.98087 5.9567 1.89024 11 1.89024C16.0433 1.89024 20.1339 5.98087 20.1339 11.0242C20.1339 16.0675 16.0433 20.1581 11 20.1581Z",
    fill: "#FF4D4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_588_24200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.72c2d4d45599708e7647b4fea4ed23b0.svg";
export { ForwardRef as ReactComponent };